module.exports = __webpack_public_path__ + "static/media/faqImage3.09d9ee8a.svg";